(function () {
  'use strict';

  // ── Helpers ──────────────────────────────────────────────────────────────

  function getVariants() {
    var el = document.getElementById('lpVariants');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function getActiveVariant(variants) {
    if (!variants || variants.length === 0) return null;
    // Single-variant: return first
    if (variants.length === 1) return variants[0];
    // Multi-variant: compose from active option pills
    var opts = Array.from(document.querySelectorAll('.v2-opts__group')).map(function (g) {
      var active = g.querySelector('.active');
      return active ? active.getAttribute('data-value') : null;
    });
    return variants.find(function (v) {
      return JSON.stringify(v.options) === JSON.stringify(opts);
    }) || null;
  }

  function updatePriceDisplay(active) {
    if (!active) return;
    var priceEl = document.getElementById('heroPrice');
    if (priceEl && active.price_fmt) priceEl.innerHTML = active.price_fmt;
    var compareEl = document.getElementById('heroCompare');
    if (compareEl) {
      if (active.compare_at_price && active.compare_at_price > active.price && active.compare_fmt) {
        compareEl.innerHTML = active.compare_fmt;
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    // Keep sticky price in sync
    var stickyPrice = document.getElementById('stickyPrice');
    if (stickyPrice && active.price_fmt) stickyPrice.innerHTML = active.price_fmt;
  }

  function updateAtcAvailability(active) {
    // Toggle the hero ATC button between buyable and sold-out when the shopper
    // switches variants client-side. Liquid only sets the initial state (for the
    // default variant), so without this a sold-out variant kept an active button.
    var btn = document.getElementById('heroCta');
    if (!btn) return; // all-variants-unavailable products render a static disabled button
    var textEl = btn.querySelector('.btn-text');
    if (active && active.available === false) {
      btn.disabled = true;
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      if (textEl) textEl.textContent = 'Ausverkauft';
    } else {
      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.cursor = '';
      if (textEl) textEl.textContent = 'In den Warenkorb';
    }
  }

  // ── ATC ──────────────────────────────────────────────────────────────────

  function wireATC() {
    var form = document.getElementById('lpv2ProductForm');
    var btn  = document.getElementById('heroCta');
    if (!form || !btn) return;
    var isSubmitting = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (isSubmitting) return;
      var variants = getVariants();
      var active = getActiveVariant(variants);
      if (!active || !active.available) return;

      // Sync the hidden variant-id input with the currently active variant
      // (variant-pill handler also writes here on click; belt + suspenders for
      // edge cases where the form is submitted without a pill click between).
      var vidEl = form.querySelector('[data-lp-variant-id]');
      if (vidEl) vidEl.value = active.id;

      // Visual loading state — prevents double-click + double-firing of pixels
      isSubmitting = true;
      btn.disabled = true;
      btn.style.opacity = '0.7';
      btn.style.cursor = 'wait';
      var textEl = btn.querySelector('.btn-text');
      var originalText = textEl ? textEl.textContent : null;
      if (textEl) textEl.textContent = 'Wird hinzugefügt…';

      function restore() {
        isSubmitting = false;
        btn.disabled = false;
        btn.style.opacity = '';
        btn.style.cursor = '';
        if (textEl && originalText !== null) textEl.textContent = originalText;
      }

      // Submit as a real Shopify product form (FormData, not JSON) so bundle
      // apps such as Kaching Bundles can intercept the /cart/add request and
      // inject bundle properties + correct quantity at runtime. Posting to
      // /cart/add.js (not /cart/add) so we still get JSON back and can confirm
      // success before redirecting — same redirect-after-success guarantee.
      // gtag fires AFTER server-confirmed add (in .then below) so we can read
      // the ACTUAL quantity (bundle apps may multiply qty or split into items).
      // Meta AddToCart is fired by Nabu — do NOT add fbq here.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (res) {
        if (!res.ok) {
          return res.json().then(function (data) {
            var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status);
            throw new Error(msg);
          }, function () {
            throw new Error('HTTP ' + res.status);
          });
        }
        return res.json();
      }).then(function (data) {
        // Fire GA add_to_cart with the ACTUAL quantity Shopify accepted.
        // For bundle apps that split into multiple line items, sum across them.
        if (window.gtag) {
          var lineItems = (data && data.items) ? data.items : (data ? [data] : []);
          var totalQty = lineItems.reduce(function (sum, it) { return sum + ((it && it.quantity) || 0); }, 0) || 1;
          window.gtag('event', 'add_to_cart', {
            currency: 'EUR',
            value: (active.price / 100) * totalQty,
            items: [{ item_id: String(active.id), quantity: totalQty }]
          });
        }
        // Keep CartJS state in sync if it's loaded (so any open drawer also
        // reflects the change), then navigate to /cart.
        if (window.CartJS && typeof window.CartJS.getCart === 'function') {
          try { window.CartJS.getCart(); } catch (e) { /* non-blocking */ }
        }
        window.location.href = '/cart';
      }).catch(function (err) {
        console.error('[lp-v2] cart/add.js failed:', err);
        restore();
        alert('Hinzufügen fehlgeschlagen: ' + (err && err.message ? err.message : 'Bitte erneut versuchen.'));
      });
    });

  }

  // ── Variant pills / swatches ─────────────────────────────────────────────

  function wireVariantPills() {
    document.querySelectorAll('.v2-opts__pill, .v2-opts__swatch').forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.closest('.v2-opts__group');
        if (!group) return;
        group.querySelectorAll('.active').forEach(function (a) {
          a.classList.remove('active');
          a.setAttribute('aria-checked', 'false');
        });
        pill.classList.add('active');
        pill.setAttribute('aria-checked', 'true');
        // Update visible selected-label if present
        var lbl = group.querySelector('.v2-opts__selected');
        if (lbl) lbl.textContent = pill.getAttribute('data-value') || '';
        // Reflect price from new active variant
        var variants = getVariants();
        var active = getActiveVariant(variants);
        if (active) updatePriceDisplay(active);
        updateAtcAvailability(active);
        // Keep the hidden variant-id input in sync so the form posts the right ID
        var vidEl = document.querySelector('[data-lp-variant-id]');
        if (vidEl && active) vidEl.value = active.id;
        // Swap main gallery image to the variant's linked image
        if (active && active.image) {
          var mainImg = document.getElementById('galMain');
          if (mainImg) {
            mainImg.removeAttribute('srcset');
            mainImg.src = active.image;
          }
          if (active.image_id) {
            var thumbs = document.querySelectorAll('.v2-gal__thumb');
            thumbs.forEach(function (t, j) {
              var matches = String(t.getAttribute('data-image-id')) === String(active.image_id);
              t.classList.toggle('v2-gal__thumb--active', matches);
              if (matches) window.__LPV2_galIdx = j;
            });
          }
        }
      });
    });
  }

  // ── Sticky bar scroll (rAF-throttled) ────────────────────────────────────

  function wireSticky() {
    var sticky = document.querySelector('.v2-sticky');
    if (!sticky) return;
    var hero = document.getElementById('hero');
    if (!hero) return;
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        // Only show sticky on mobile (CSS already hides on >=769px via !important,
        // but we also guard here so display:flex doesn't flash on desktop)
        if (window.innerWidth <= 768) {
          sticky.style.display = 'flex';
          sticky.classList.toggle('visible', window.scrollY > hero.offsetHeight);
        }
        ticking = false;
      });
    }, { passive: true });
  }

  // ── Gallery ───────────────────────────────────────────────────────────────
  // In production, Liquid renders all images server-side.
  // __LPV2_galImages is set inline by the section Liquid before this script runs.

  function wireGallery() {
    var mainImg = document.getElementById('galMain');
    if (!mainImg) return;

    // Thumbnail clicks
    document.querySelectorAll('.v2-gal__thumb').forEach(function (thumb, i) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelectorAll('.v2-gal__thumb').forEach(function (t) {
          t.classList.remove('v2-gal__thumb--active');
        });
        thumb.classList.add('v2-gal__thumb--active');
        var src = thumb.getAttribute('data-full') || thumb.src;
        if (src) {
          mainImg.removeAttribute('srcset');
          mainImg.src = src;
          window.__LPV2_galIdx = i;
        }
      });
    });

    // Prev / next nav buttons
    var prevBtn = document.getElementById('galPrev');
    var nextBtn = document.getElementById('galNext');

    function stepGallery(dir) {
      var images = window.__LPV2_galImages;
      if (!images || images.length === 0) return;
      window.__LPV2_galIdx = ((window.__LPV2_galIdx || 0) + dir + images.length) % images.length;
      var idx = window.__LPV2_galIdx;
      mainImg.removeAttribute('srcset');
      mainImg.src = images[idx];
      document.querySelectorAll('.v2-gal__thumb').forEach(function (t, j) {
        t.classList.toggle('v2-gal__thumb--active', j === idx);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stepGallery(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stepGallery(1); });
  }

  // ── FAQ accordion ─────────────────────────────────────────────────────────
  // In production the Liquid template renders FAQ items with static buttons.
  // Wire the toggle here so we don't need inline onclick attributes in Liquid.

  function wireFaq() {
    document.querySelectorAll('.v2-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('open');
        var answer = btn.nextElementSibling;
        if (answer) answer.classList.toggle('open');
      });
    });
  }

  // ── CTA scroll button ─────────────────────────────────────────────────────

  function wireCtaScroll() {
    document.querySelectorAll('[data-scroll-to-atc], [data-scroll-to-hero]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('heroCta') || document.getElementById('hero');
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Flash highlight on the ATC so the user knows where we sent them
        target.classList.add('v2-btn--flash');
        setTimeout(function () { target.classList.remove('v2-btn--flash'); }, 1200);
      });
    });
  }

  // ── Boot ─────────────────────────────────────────────────────────────────

  function init() {
    wireATC();
    wireVariantPills();
    wireSticky();
    wireGallery();
    wireFaq();
    wireCtaScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();




